export enum TrafikCoveragesIds {
    TRAFIK = 300001,
    PREMIESKATT = 640001
}
export enum TrafikCoveragesNames {
    TRAFIK = 'Trafik',
    CRISIS = 'Kris'
}
export enum HalvCoveragesIds {
    TRAFIK = 30,
    DELKASKO = 31,
    PREMIESKATT = 64
}
export enum HalvCoveragesNames {
    TRAFIK = 'Trafik',
    CRISIS = 'Kris',
    FIREGLASSTHEFT = 'Brand, Glas, Stöld',
    RESCUE = 'Maskin, Räddning',
    LEGAL = 'Rättsskydd',
    ALLRISK = 'Allrisk bil'
}
export enum HelCoveragesIds {
    TRAFIK = 30,
    DELKASKO = 31,
    VAGNSKADA = 32,
    PREMIESKATT = 64
}
export enum HelCoveragesNames {
    TRAFIK = 'Trafik',
    CRISIS = 'Kris',
    FIREGLASSTHEFT = 'Brand, Glas, Stöld',
    RESCUE = 'Maskin, Räddning',
    LEGAL = 'Rättsskydd',
    ALLRISK = 'Allrisk bil',
    DAMAGE = 'Vagnskada'
}
export enum PlusCoveragesIds {
    PLUSPACKAGE = 1179
}
